export const GET_PROJECT_STATUSES = 'projectStatuses/GET_PROJECT_STATUSES';
export const GET_PROJECT_STATUSES_SUCCESS = 'projectStatuses/GET_PROJECT_STATUSES_SUCCESS';
export const GET_PROJECT_STATUSES_ERROR = 'projectStatuses/GET_PROJECT_STATUSES_ERROR';
